import { combineReducers } from '@reduxjs/toolkit';
import coachReducer from './coach/coachSlice';
import clientReducer from './client/clientSlice';
import noteReducer from './note/noteSlice';
import activityReducer from './activity/activitySlice';
import appointmentReducer from './appointment/appointmentSlice';
import forgetPasswordReducer from './forgetPassword/forgetPasswordSlice';
import { onboardingReducer } from './onboarding/onboardingSlice';
import activityLibraryReducer from './activityLibrary/activityLibrarySlice';
import notificationReducer from './notification/notificationSlice';
import chatReducer from './chat/chatSlice';
import { userGroupsReducer } from './userGroups/userGroupsSlice';
import { screenReducer } from './screen/slice';
import subscriptionReducer from './subscription/subscriptionSlice';
import bookingReducer from './booking/bookingSlice';
import { miniwebReducer } from './miniweb/miniwebSlice';
import { coachGroupReducer } from './coachGroup/coachGroupSlice';

const rootReducer = combineReducers({
  coach: coachReducer,
  client: clientReducer,
  note: noteReducer,
  activity: activityReducer,
  appointment: appointmentReducer,
  forgetPassword: forgetPasswordReducer,
  onboarding: onboardingReducer,
  activityLibrary: activityLibraryReducer,
  notification: notificationReducer,
  chat: chatReducer,
  userGroups: userGroupsReducer,
  screen: screenReducer,
  subscription: subscriptionReducer,
  booking: bookingReducer,
  miniweb: miniwebReducer,
  coachGroup: coachGroupReducer,
});

export type RootState = ReturnType<typeof rootReducer>;

export default rootReducer;
